export const cars =[
    {
        image: "/images/Toyota_Rav4/1.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/Toyota_Rav4/2.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/Toyota_Rav4/3.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/Toyota_Rav4/4.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/Toyota_Rav4/5.jpg",
        // title: "Toyota Prado"
    }
];